<template>
  <v-app :class="$vuetify.breakpoint.xs ? 'mobile' : ''">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
  computed: {
    eventSettings() {
      return this.$store.getters["getSettings"];
    },
    daysOfWeekSelected: {
      get() {
        return this.$store.getters["getDaysOfWeekSelected"];
      },
      set(days) {
        return this.$store.dispatch("changeDaysOfWeekSelected", days);
      },
    },
    pageHeight() {
      return this.$refs.app.clientHeight;
    },
    isLazyLoaded() {
      return this.$store.getters["getIsLazyLoaded"];
    },
    isHeavyLoaded() {
      return this.$store.getters["getIsHeavyLoaded"];
    },
    sessionsPerDayOfWeekSelected() {
      return this.$store.getters["getSessionsPerDayOfWeekSelected"];
    },
  },
  methods: {
    changeEvent(eventid) {
      this.$store.dispatch("changeEventSelected", eventid);
    },
    changeLanguage(language) {
      this.$store.dispatch("changeLanguage", language);
    },
    refreshCalendar() {
      this.changeEvent(this.$route.params.eventid);
      this.changeLanguage(this.$route.params.language);
      this.fetchSettings();
      this.fetchCalendarEvents();
    },

    async fetchSettings() {
      await this.$store.dispatch("fetchCalendarSettings");

      this.$store.dispatch(
        "changeCalendarStartingDate",
        this.eventSettings.eventStartDate
      );

      //Calendar CSS Settings
      this.$root.$el.style.setProperty(
        "--calendar-title-font-color",
        this.eventSettings.calendarTitleFontColor
      );

      this.$root.$el.style.setProperty(
        "--calendar-header-weekday-color",
        this.eventSettings.calendarHeaderWeekdayFontColor
      );

      this.$root.$el.style.setProperty(
        "--calendar-header-day-color",
        this.eventSettings.calendarHeaderDayFontColor
      );

      //Day CSS Settings
      this.$root.$el.style.setProperty(
        "--day-header-background-color",
        this.eventSettings.dayHeaderBackgroundColor
      );

      this.$root.$el.style.setProperty(
        "--day-header-font-color",
        this.eventSettings.dayHeaderFontColor
      );

      this.$root.$el.style.setProperty(
        "--day-font-color",
        this.eventSettings.dayFontColor
      );
    },
    async fetchCalendarEvents() {
      await this.$store.dispatch("fetchCalendarEvents");
    },
    async fetchSessionsPerDayOfWeekSelected(params) {
      await this.$store.dispatch("fetchSessionsPerDayOfWeekSelected", params);
    },
    async fetchSessionsPerTypeSelected(params) {
      await this.$store.dispatch("fetchSessionsPerTypeSelected", params);
    },
  },
  updated() {
    this.refreshCalendar();
  },
  created() {
    this.refreshCalendar();
  },
  watch: {},
};
</script>
